import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, G, Rect, Path, Circle, Defs, ClipPath } from 'react-native-svg';

export const IllustrationCardAlert = ({
  width = 48,
  height = 48,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    viewBox="0 0 111 110"
    className={className}
    fill="none"
  >
    <G clipPath="url(#clip0_15078_7110)">
      <Rect
        x="111"
        y="17.4219"
        width="84.9271"
        height="56.7555"
        rx="7.11788"
        transform="rotate(90 111 17.4219)"
        fill="#FE7165"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.053 102.35C105.769 97.1553 103.797 92.0194 100.083 87.8422C91.4108 78.0859 76.5305 77.2626 66.8508 86.0014C62.012 90.3686 59.3879 96.2949 59.0542 102.35L106.053 102.35Z"
        fill="#FDBD9A"
      />
    </G>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 37.1846C1 53.8551 14.5141 67.3692 31.1846 67.3692C32.4727 67.3692 33.7419 67.2886 34.9876 67.132C36.2332 67.2886 37.5024 67.3692 38.7905 67.3692C40.0982 67.3692 41.3865 67.2861 42.6503 67.1248C43.9206 67.2878 45.2156 67.3718 46.5303 67.3718C46.5973 67.3718 46.6642 67.3716 46.7311 67.3712V67.3716H70.2017C73.7988 67.3716 76.7149 64.4555 76.7149 60.8583L76.7148 37.2539L76.7149 37.1872C76.7149 20.5167 63.2008 7.00258 46.5303 7.00258C45.2226 7.00258 43.9343 7.08574 42.6705 7.24705C41.4001 7.08404 40.1051 7 38.7905 7C37.5024 7 36.2332 7.08068 34.9876 7.23727C33.7419 7.08068 32.4727 7 31.1846 7C14.5141 7 1 20.5141 1 37.1846Z"
      fill="#FFE5D8"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9609 64.0251C17.0732 64.0251 5.00427 51.9562 5.00427 37.0685C5.00427 22.1807 17.0732 10.1118 31.9609 10.1118C46.8487 10.1118 58.9175 22.1807 58.9175 37.0685C58.9175 37.0883 58.9175 37.1082 58.9175 37.1281H58.9175V64.025H32.1402V64.0245C32.0805 64.0249 32.0207 64.0251 31.9609 64.0251Z"
      fill="#FDBD9A"
    />
    <Rect
      x="30.1104"
      y="24.7051"
      width="3.70117"
      height="18.1199"
      rx="1.29836"
      fill="#F2F2F2"
    />
    <Circle cx="31.9609" cy="47.1983" r="2.23151" fill="#F2F2F2" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.7535 64.0251C23.8657 64.0251 11.7968 51.9562 11.7968 37.0685C11.7968 22.1807 23.8657 10.1118 38.7535 10.1118C53.6412 10.1118 65.7101 22.1807 65.7101 37.0685C65.7101 37.0884 65.7101 37.1084 65.71 37.1284H65.7101V64.0252H38.9328V64.0245C38.873 64.0249 38.8133 64.0251 38.7535 64.0251Z"
      fill="#FF8D78"
    />
    <Rect
      x="36.9026"
      y="24.7051"
      width="3.70117"
      height="18.1199"
      rx="1.29836"
      fill="#F2F2F2"
    />
    <Circle cx="38.7531" cy="47.1983" r="2.23151" fill="#F2F2F2" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.6657 64.0251C30.778 64.0251 18.7091 51.9562 18.7091 37.0685C18.7091 22.1807 30.778 10.1118 45.6657 10.1118C60.5535 10.1118 72.6224 22.1807 72.6224 37.0685C72.6224 37.0884 72.6223 37.1084 72.6223 37.1284H72.6224V58.7087C72.6224 61.645 70.2421 64.0252 67.3059 64.0252H45.845V64.0245C45.7853 64.0249 45.7255 64.0251 45.6657 64.0251Z"
      fill="#FE7165"
    />
    <Rect
      x="42.9981"
      y="19.2476"
      width="5.33492"
      height="26.1182"
      rx="1.87147"
      fill="#F2F2F2"
    />
    <Circle cx="45.6657" cy="51.6701" r="3.21653" fill="#F2F2F2" />
    <Defs>
      <ClipPath id="clip0_15078_7110">
        <Rect
          x="54.2444"
          y="17.4219"
          width="56.7555"
          height="84.928"
          rx="7.69745"
          fill="white"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
